import React from "react";


export function DataTable(props) {
    return <div className="datatable" {...props}>
        {props.children}
    </div>
}
export function Row(props) {
    return <div className="datatable__row">
        <div className="datatable__row-header"><p>{props.label}</p></div>
        <div className="datatable__row-entry">{props.noParagraph ? props.children : <p>{props.children}</p>}</div>
    </div>
}

export function RowHeader(props) {
    return <div className="datatable__row">
        <div className="datatable__row-fullheader">
            <h4>{props.label}</h4>
        </div>
    </div>
}

export function SaveTable(props) {
    return <form onSubmit={(ev) => { ev.preventDefault(); props.onSave(ev); }}>
        <DataTable>
            {props.children}
            <Row label=""><button className="btn btn-block btn-primary" disabled={props.disabled}>{props.buttonLabel || "Save"}</button></Row>
            {props.postSaveEntries}

        </DataTable>
    </form>
}

export default DataTable;